import React from 'react';
import { Outlet } from "react-router-dom";
import { Header } from "./components/header"
import { MainNavLinks } from "./navLinks";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { OfflineToast } from './components/offlineNotification/offlineToast';
import FeedbackProvider from './components/contexts/FeedbackProvider';
import UsePageViews from './components/customHooks/usePageViews';
import AppVersion from './components/AppVersion';
import { useState } from 'react';
import PreferredUnitsProvider from './components/contexts/PreferredUnitsContext';
export const PwaInstallPrompt = React.createContext(Promise.reject);

function App() {
    const [installPromptEvent, setInstallPromptEvent] = useState()
    const productionEnv = process.env.NODE_ENV === 'production';

    const queryClient = new QueryClient({
        defaultOptions: {
            queries: {
                refetchOnWindowFocus: false,
            },
        },
    });

    window.addEventListener("beforeinstallprompt", (event) => setInstallPromptEvent(event));

    return (
        <QueryClientProvider client={queryClient}>
            <PwaInstallPrompt.Provider value={installPromptEvent}>
                <FeedbackProvider>
                    <PreferredUnitsProvider>
                        <div className="App">
                            <Header links={MainNavLinks} />
                            <Outlet />
                            <OfflineToast />
                            <AppVersion />
                        </div>
                        {productionEnv && <UsePageViews />}
                    </PreferredUnitsProvider>
                </FeedbackProvider>
            </PwaInstallPrompt.Provider>
        </QueryClientProvider>
    );
}

export default App;
